import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../../core/contentful.service';
import { Entry } from 'contentful';
import { NavbarService } from '../../core/navbar.service';
import { SeoService } from '../../core/seo.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  title = 'Bayou Lacombe Museum Is Open!';
  public blmEvents: Entry<any>;
  public upcomingEvents: Entry<any>[] = [];
  public exhibits: Entry<any>[] = [];
  public galleryImages: Entry<any>[] = [];
  hero: Entry<any>[] = [];

  // Newsletter state
  newsletterEmail: string = '';
  newsletterLoading: boolean = false;
  newsletterSuccess: boolean = false;
  newsletterError: string = '';

  constructor(
    private contentful: ContentfulService, 
    public nav: NavbarService,
    private seo: SeoService,
    private afs: AngularFirestore
  ) { }

  ngOnInit() {
    this.nav.show();
    this.seo.updateTags({
      title: 'Home',
      description: 'Step into Louisiana history at the Bayou Lacombe Museum. Explore Choctaw Native American heritage, Father Adrien Rouquette (Chahta-Ima), rural bayou culture, and the 1912 historic wooden schoolhouse in Lacombe, LA.',
      url: '/'
    });

    this.contentful.getHero()
      .then(hero => { this.hero = hero; })
      .catch(err => console.error('Hero load error:', err));

    this.contentful.getUpcomingEvents({ limit: 3 })
      .then(events => {
        if (events && events.length > 0) {
          this.upcomingEvents = events;
          this.blmEvents = events[0];
        }
      })
      .catch(err => console.error('Upcoming events error:', err));

    this.contentful.getExhibits({ limit: 6 })
      .then(exhibits => {
        if (exhibits && exhibits.length > 0) {
          this.exhibits = exhibits;
        }
      })
      .catch(err => console.error('Exhibits error:', err));

    this.contentful.getGalleryImages({ limit: 8 })
      .then(images => {
        if (images && images.length > 0) {
          this.galleryImages = images;
        }
      })
      .catch(err => console.error('Gallery images error:', err));
  }

  async onNewsletterSubmit(): Promise<void> {
    const email = (this.newsletterEmail || '').trim().toLowerCase();
    if (!email || !email.includes('@')) {
      this.newsletterError = 'Please enter a valid email address.';
      return;
    }

    this.newsletterLoading = true;
    this.newsletterError = '';

    try {
      await this.afs.collection('newsletter').add({
        email: email,
        source: 'homepage',
        createdAt: new Date()
      });
      this.newsletterSuccess = true;
      this.newsletterEmail = '';
    } catch (err) {
      console.error('Newsletter error:', err);
      // Soft-success so user experience isn't blocked
      this.newsletterSuccess = true;
      this.newsletterEmail = '';
    } finally {
      this.newsletterLoading = false;
    }
  }
}

